import React from 'react';
import './emptyState.css';

export const EmptyState = ({ icon = 'book', title, message, action }) => {
    return (
        <div className="library-empty-state" data-testid="library-empty-state">
            <div className="library-empty-icon">
                <i className={`fa fa-${icon} fa-4x primary-color`}></i>
            </div>
            <h3 className="library-empty-title">{title}</h3>
            {message && <p className="library-empty-message">{message}</p>}
            {action && <div className="library-empty-action mt20">{action}</div>}
        </div>
    );
};

export default EmptyState;
